module.exports = __webpack_public_path__ + "static/img/br_hands_ok.2aa51f1b.webp";